<table class="table participants clickable">
    <thead>
        <tr>
            <th></th>
            <th>{{ 'full-data.account-number' | translate }}</th>
            <th class="text-right" *ngIf="!isAdmin">
                {{ 'form.status' | translate }}
            </th>
            <th class="text-right" *ngIf="isAdmin">
                {{ 'form.validated' | translate }}
            </th>
        </tr>
    </thead>
    <tbody>
        <tr (click)="onEdit()">
            <td>
                <i class="icon-bank"></i>
            </td>
            <td>
                <span *ngIf="iban">{{ maskIban }}</span>
                <span *ngIf="!iban">{{ 'general.pending' | translate }}</span>
            </td>
            <td *ngIf="!isAdmin">
                <i class="icon-check green-icon-check float-right" *ngIf="isComplete"></i>
                <i class="icon-exclamation red-icon-exclamation float-right" *ngIf="!isComplete"></i>
            </td>
            <td *ngIf="isAdmin">
                <i class="icon-check green-icon-check float-right" *ngIf="isValidated"></i>
                <i class="icon-exclamation red-icon-exclamation float-right" *ngIf="!isValidated"></i>
            </td>
        </tr>
    </tbody>
</table>
